import React, { useState } from "react";

interface IInputForm {
  addTodo: AddFn;
}

const InputForm = ({ addTodo }: IInputForm) => {
  const [task, setTask] = useState("");
  const [priority, setPriority] = useState<"low" | "medium" | "high">("medium");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (task.trim() !== "") {
      addTodo(task, priority);
      setTask("");
      setPriority("medium");
    } else {
      alert("Please fill the input box");
      setTask("");
    }
  };

  return (
    <form className="input-form" onSubmit={handleSubmit}>
      <input
        className="input-task"
        placeholder="Enter the todo..."
        type="text"
        maxLength={40}
        value={task}
        onChange={(e) => setTask(e.target.value)}
      />

      <select
        className="priority-select"
        value={priority}
        onChange={(e) =>
          setPriority(e.target.value as "low" | "medium" | "high")
        }>
        <option value="low">🟢 Low</option>
        <option value="medium">🟡 Medium</option>
        <option value="high">🔴 High</option>
      </select>

      <button className="btn-hover btn-color" type="submit" disabled={!task}>
        Add New Todo
      </button>
    </form>
  );
};

export default InputForm;